import React, {useContext} from "react";
import { css } from "emotion";
import { colors, textSizes, boxStyles } from "../../styles/theme";
import auth from "../../services/api/auth";
import { withRouter } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalState";
import IconTextGeneric from "../IconTextGeneric";

const LogoutButton = ({ history }) => {
  const { logOut } = useContext(GlobalContext);

  const handleLogout = () => {
    auth.logOut().then(() => {
      history.push("/login");
      logOut();
    });
  };

  return (
    <div className={container} onClick={handleLogout}>
      <IconTextGeneric text="Log Out" icon="power-off" />
    </div>
  );
};

export default withRouter(LogoutButton);

const container = css`
  cursor: pointer;
  font-size: ${textSizes.normal};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: center;
  margin-top: 10px;
  margin-left: 15px;
  
  .icon-text {
    margin-right: 0;
    
    p {
      font-size: 14px;
      font-weight: 500;
    }
  }
`;
